import * as H from 'history';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import AuthRequestStatus from '../enums/AuthRequestStatus';
import { AuthRoutesState } from '../types/AuthRoutesState';

interface Props extends RouteProps {
    authRoutesState: AuthRoutesState;
}

interface LocationState {
    from: {
        pathname: string;
    };
}

function UnauthorizedRoute<React, FC>({ authRoutesState, children, ...rest }: Props) {
    return (
        <Route
            {...rest}
            render={({ location }) => {
                const loc = location as H.Location<LocationState>;
                return authRoutesState.requestStatus === AuthRequestStatus.configSuccess ? (
                    <Redirect to={loc.state ? loc.state.from : '/'} />
                ) : (
                    <>{children}</>
                );
            }}
        />
    );
}

export default UnauthorizedRoute;
